import ReactSpinner from "react-svg-spinner"

export type SpinnerProps = {
	ariaLabel?: string
	color: string
	size: string
}

export const Spinner = ({ ariaLabel = "Waiting loader", color, size }: SpinnerProps) => {
	return <ReactSpinner aria-label={ariaLabel} color={color} size={size} />
}
